import { useSelector, useDispatch } from "react-redux";
import {
    Container,
    Grid,
    Box,
    Paper
} from "@mui/material";

import Button from "@/components/ph/Button";

import { nextStep, updateQuoteDataInitial } from "../../quote/quoteSlice";
import { isFormValid } from "../selectors/quoteSelectors";

import { trackEventStep1Quote } from "../../../utils/analytics";

const QuoteButton = () => {
  const dispatch = useDispatch();
  const canSubmit = useSelector(isFormValid);

  const vehicleData = useSelector((state) => state.vehicle.formValues);
  const driverData = useSelector((state) => state.driver.formValues);
  const contractorData = useSelector((state) => state.contractor.formValues);
  const termsAndConditions = useSelector((state) => state.quote.termsAndConditions);

  const handleSubmit = async () => {
    if (canSubmit) {
      dispatch(updateQuoteDataInitial({
        vehicleData,
        driverData,
        contractorData,
        termsAndConditions
      }));

      try {
        await trackEventStep1Quote();
      } catch (error) {
        console.warn("Error en analítica al cotizar:", error);
      }

      dispatch(
        nextStep()
      );
    }
  };

  return (
  <Container maxWidth="md" disableGutters={{ xs: true, md: false }}>
    <Paper elevation={0} sx={{ p: { md: 2 }, mb: { xs: 2, md: 2 } }}>
      <Grid size={{ xs: 12, md: 12 }}>
        <Box sx={{
          mt: 6,
          maxWidth: {
            xs: 'none',
            md: 225
          },
          mx: 'auto'
        }} alignItems="center">
          <Button
              label="Cotizar"
              onClick={handleSubmit}
              disabled={!canSubmit}
              variant="black"
          />
        </Box>
      </Grid>
    </Paper>
  </Container>
  );
};

export default QuoteButton;